<template>
  <div class="mt-1 ml--3">
    <tbody>
      <tr>
        <td class="col-md-1">
          <div
            class="form-control form-control-sm btn-block dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >Order By: {{$parent.$parent.orderByOptions[$parent.$parent.orderBy].name}}</div>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a
              v-for="orderByOption in $parent.$parent.orderByOptions"
              :key="orderByOption.value"
              class="dropdown-item"
              @click="changeOrderBy(orderByOption.value)"
            >{{orderByOption.name}}</a>
          </div>
        </td>
        <td class="col-md-1">
          <div
            class="form-control form-control-sm btn-block dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >Order By Direction: {{$parent.$parent.orderByDirOptions[$parent.$parent.orderByDir].name}}</div>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a
              v-for="orderByDirOption in $parent.$parent.orderByDirOptions"
              :key="orderByDirOption.value"
              class="dropdown-item"
              @click="$parent.$parent.changeOrderByDir(orderByDirOption.value)"
            >{{orderByDirOption.name}}</a>
          </div>
        </td>
        <td>
          <div></div>
        </td>
      </tr>
      <tr v-for="(filter, index) in $parent.$parent.filters" :key="filter.field">
        <td class="col-md-1">
          <div
            class="form-control form-control-sm btn-block dropdown-toggle"
            id="dropdownMenuButton"
          >Filter By: {{filter.name}}</div>
        </td>
        <td class="col-md-1">
          <div
            class="form-control form-control-sm btn-block dropdown-toggle"
            id="dropdownMenuButton"
          >Value: {{Array.isArray(filter.value) ? filter.value.map(v => v.name).join(", ") : filter.value.name}}</div>
        </td>
        <td class="td-actions col-md-1">
          <button
            type="button"
            rel="tooltip"
            class="btn btn-danger btn-icon btn-sm"
            data-original-title
            @click="$parent.$parent.removeFilter(index)"
            title
          >
            <i class="fa fa-minus pt-1"></i>
          </button>
        </td>
      </tr>
      <tr v-for="(pendingFilter, index) in pendingFilters" :key="pendingFilter.field">
        <td class="col-md-1">
          <div
            class="form-control form-control-sm btn-block dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >Filter By: {{pendingFilter.name}}</div>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a
              v-for="filterOption in unusedFilterOptions"
              :key="filterOption.field"
              class="dropdown-item"
              @click="changeFilterBy(filterOption, index)"
            >{{filterOption.name}}</a>
          </div>
        </td>
        <td class="col-md-1">
          <div
            class="form-control form-control-sm btn-block dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >Value: {{pendingFilter.value != undefined ? (Array.isArray(pendingFilter.value) ? pendingFilter.value.map(v => v.name).join(", ") : pendingFilter.value.name) : null}}</div>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" v-if="pendingFilter.name" style="height: 200px; overflow:scroll;">
            <div
              v-for="pendingFilterValueOption in pendingFilter.getValueOptions(pendingFilter.field)"
              :key="pendingFilterValueOption.id"
              class="dropdown-item"
            >
              <div v-if="Array.isArray(pendingFilter.value)">
                <input
                  type="checkbox"
                  class="mr-2"
                  @click="changeFilterByValue(pendingFilterValueOption, index)"
                />
                <a>{{pendingFilterValueOption.name}}</a>
              </div>
              <div v-else>
                <a
                  @click="changeFilterByValue(pendingFilterValueOption, index)"
                >{{pendingFilterValueOption.name}}</a>
              </div>
            </div>
          </div>
        </td>
        <td class="td-actions col-md-1">
          <button
            type="button"
            rel="tooltip"
            class="btn btn-success btn-icon btn-sm"
            data-original-title
            @click="addFilterBy(pendingFilter, index)"
            title
          >
            <i class="ni ni-check-bold pt-1"></i>
          </button>
        </td>
      </tr>
    </tbody>
    <div class="row ml-3 mt-3" v-if="$parent.$parent.orderBy ==='enrollDate'">
      <div class="col-md-1 mb-0.1">
        <i class="fa fa-plus-circle" @click="pendingFilters.push({})"></i>
      </div>
      <div class="col-md-1 mb-0.1">
        <i class="fa fa-minus-circle" @click="pendingFilters.pop()"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "potentialeesfilters",
  data() {
    return {
      pendingFilters: []
    };
  },
  computed: {
    unusedFilterOptions() {
      const pParent = this.$parent.$parent;
      const pFilterFields = Object.values(this.pendingFilters).map(pFilter => {
        return pFilter.field;
      });
      const filterFields = Object.values(pParent.filters).map(filter => {
        return filter.field;
      });

      return pParent.filtersOptions.filter(filter => {
        return (
          !pFilterFields.includes(filter.field) &&
          !filterFields.includes(filter.field)
        );
      });
    }
  },
  methods: {
    changeOrderBy(orderByOptionValue) {
      if (orderByOptionValue !== "enrollDate") {
        this.pendingFilters = [];
        this.$parent.$parent.filters = [];
      }
      this.$parent.$parent.changeOrderBy(orderByOptionValue);
    },
    changeFilterBy(filterOption, index) {
      this.pendingFilters[index] = filterOption;

      if (Array.isArray(this.pendingFilters[index].value)) {
        this.pendingFilters[index].value = [];
      } else {
        this.pendingFilters[index].value = "";
      }

      this.pendingFilters = [].concat(this.pendingFilters);
    },
    changeFilterByValue(value, index) {
      if (Array.isArray(this.pendingFilters[index].value)) {
        if (this.pendingFilters[index].value.includes(value)) {
          this.pendingFilters[index].value.splice(
            this.pendingFilters[index].value.indexOf(value),
            1
          );
        } else {
          this.pendingFilters[index].value.push(value);
        }
        this.pendingFilters = [].concat(this.pendingFilters);
      } else {
        this.pendingFilters[index].value = value;
      }
    },
    addFilterBy(pendingFilter, index) {
      if (pendingFilter.name != undefined && pendingFilter.value != "") {
        this.$parent.$parent.addFilter(pendingFilter);

        this.pendingFilters.splice(index, 1);
      }
    }
  }
};
</script>
